module.exports = __webpack_public_path__ + "files/9abbdb4d2faee2d5f91e547b6f6819a2.png";